import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

interface FieldRowProps {
  label: string;
  hint?: ReactNode;
  children: ReactNode;
}

/** Small uppercase-ish label above a control that is not a TextField (segmented groups, chips). */
export function FieldRow({ label, hint, children }: FieldRowProps) {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mb: '8px',
          fontSize: 11.5,
          color: 'text.secondary',
          fontWeight: 700,
        }}
      >
        {label}
        {hint}
      </Box>
      {children}
    </Box>
  );
}
